<mat-sidenav-container class="side-nav">
	<mat-sidenav
		*ngIf="showSideNav()"
		#mainSideNav
		[mode]="(isMobile$ | async) ? 'over' : 'side'"
		[ngClass]="{'collapsed': (collapsed$ | async), 'mobile': (isMobile$ | async)}"
		[(opened)]="opened"
		role="region"
		[@slideInOut]="{value: ((collapsed$ | async) || !opened) ? 'collapsed' : 'expanded', params: {lowWidth: !opened ? '0px' : '77px'}}">
		<button
			*ngIf="(isMobile$ | async)"
			class="close-button"
			mat-icon-button
			[attr.aria-label]="'dashboard_collapse-sidebar' | translate"
			(click)="mainSideNav.toggle()">
			<mat-icon class="ficon-app-x"></mat-icon>
		</button>
		<button
			*ngIf="(isMobile$ | async) === false"
			class="expand-button"
			mat-icon-button
			[matTooltip]="((collapsed$ | async) ? 'common_open-sidebar' : 'common_close-sidebar') | translate"
			(click)="toggleCollapse()">
			<mat-icon class="{{ (collapsed$ | async) ? 'ficon-app-chevron-right' : 'ficon-app-chevron-left' }}"></mat-icon>
		</button>
		<dashboard-navigation [collapsed$]="collapsed$" [showMessage$]="showMessage$"></dashboard-navigation>
	</mat-sidenav>
	<mat-sidenav-content [@slideInOutContent]="((collapsed$ | async) || !opened) ? 'collapsed' : 'expanded'" [ngClass]="{'noMargin': (isMobile$ | async) || !showSideNav()}">
		<div class="main">
			<dashboard-header role="region" (toggleSideNav)="mainSideNav.toggle()" [showSideNavToggle$]="isMobile$"></dashboard-header>
			<ng-content></ng-content>
		</div>
	</mat-sidenav-content>
</mat-sidenav-container>
